export default "__VITE_ASSET__BsIJa6jF__"